import React from 'react'
import { WiserPromptPopup } from './WiserPromptPopup'

export interface WiserMomentarySwitchesPromptPopupProps {
  onAction: (params: {
    shouldConfigureMomentarySwitches: boolean
    doNotAskAgain: boolean
  }) => void
}

export function WiserMomentarySwitchesPromptPopup({
  onAction,
}: WiserMomentarySwitchesPromptPopupProps) {
  const onYes = (doNotAskAgain: boolean) => onAction({
    shouldConfigureMomentarySwitches: true,
    doNotAskAgain,
  })

  const onNo = (doNotAskAgain: boolean) => onAction({
    shouldConfigureMomentarySwitches: false,
    doNotAskAgain,
  })

  return (
    <WiserPromptPopup
      onYes={onYes}
      onNo={onNo}
    >
      These require momentary switches
      <div style={{ paddingBottom: '0.5em' }} />
      Do you want to configure them now?
    </WiserPromptPopup>
  )
}
